import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { IModules } from '../../../core/models/disciplines';

interface NewModuleState {
  modules: IModules[];
  moduleSlug: string | null;
  module: IModules | null;
  setModuleSlug: (slug: string) => void;
  setModule: (module: IModules) => void;
  setModules: (modules: IModules[]) => void;
  resetModule: () => void;
}

export const useNewModuleStore = create<NewModuleState>()(
  persist(
    (set) => ({
      modules: [],
      module: null,
      moduleSlug: null,
      setModule: (module: IModules) => set({ module: module }),
      setModuleSlug: (slug: string) => set({ moduleSlug: slug }),
      setModules: (modules: IModules[]) => set({ modules: modules }),
      resetModule: () => set({ modules: [], module: null, moduleSlug: null })
    }),
    {
      name: 'new-discipline-module',
    }
  )
);